export function mapFeatureFlags(input) {
    return {
        data: mapFeatureFlagsData(input.data),
        v: input.v,
    };
}
export function mapFeatureFlagsData(input) {
    if (!input)
        return null;
    const inputResults = input.results;
    const results = {};
    Object.keys(inputResults)
        .map((key) => inputResults[key])
        .forEach((flag) => (results[flag.key] = mapFeatureFlag(flag)));
    return { results };
}
export function mapFeatureFlag(input) {
    const { found, key, poll_time_sec: pollTimeSec, scope, tag, value } = input;
    return {
        found,
        key,
        tag,
        value,
        scope: mapFeatureFlagScope(scope),
        pollTime: pollTimeSec > 0 ? pollTimeSec * 1000 : pollTimeSec,
    };
}
export function mapFeatureFlagScope(input) {
    if (!input)
        return null;
    const { type, ttl_sec: ttlSec } = input;
    return {
        type,
        ttl: ttlSec > 0 ? ttlSec * 1000 : ttlSec,
    };
}
